import type { PropsWithChildren } from "react";
import { FormControl } from "reshaped";

import { type AnyFieldProps, getErrorMessage, type Validity } from "./utilities";

export type FieldProps = PropsWithChildren<AnyFieldProps<any>> & {
    isDirty?: boolean;
    validity?: Validity;
};

export function Field(props: FieldProps) {
    const { children, label, validity, isDirty } = props;
    const showError = isDirty === true && validity?.valid === false;
    return (
        <FormControl hasError={showError}>
            {label ? <FormControl.Label>{label}</FormControl.Label> : null}
            {children}
            {showError ? (
                <FormControl.Error>{getErrorMessage(validity.error)}</FormControl.Error>
            ) : null}
        </FormControl>
    );
}
